import { CSSProperties } from 'react';
import { PositionEnum } from '@/types/shared';

export const FLEX_CONTAINER = {
  horizontile: 'div' as const,
  vertical: 'div' as const
};

export const POSITION_ABSOLUTE: Record<PositionEnum, CSSProperties> = {
  [PositionEnum.TOP_RIGHT]: { position: 'absolute', top: '0', right: '0', padding: '5px' },
  [PositionEnum.TOP_LEFT]: { position: 'absolute', top: '0', left: '0', padding: '5px' },
  [PositionEnum.TOP_CENTER]: { position: 'absolute', top: '0', left: '50%', padding: '5px' },
  [PositionEnum.CENTER]: { position: 'absolute', bottom: '50%', left: '50%', padding: '5px' },
  [PositionEnum.BOTTOM_RIGHT]: { position: 'absolute', bottom: '0', right: '0', padding: '5px' },
  [PositionEnum.BOTTOM_LEFT]: { position: 'absolute', bottom: '0', left: '0', padding: '5px' },
  [PositionEnum.BOTTOM_CENTER]: { position: 'absolute', bottom: '0', left: '50%', padding: '5px' },
};